export default "__VITE_ASSET__B9QGdi1u__"